import { Dispatch } from '@reduxjs/toolkit'
import { PaymentMethodDto } from 'api/PaymentProvider/Types/PaymentMethodDto'
import { UpdateTransactionStatus } from 'api/Transaction/Types/UpdateTransactionStatus'
import { Toast } from 'components/Toast/Toast'
import { PageQuery } from 'utils/api'
import { PaymentApiClient } from 'utils/api/paymentApi'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { transactionSlice } from './transaction.slice'

export const fetchInterestRatesEligibilityTypes = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getInterestRatesEligibilityCriteriaTypes()
      dispatch(transactionSlice.actions.setInterestRatesEligibilityTypesAction(response))
    } catch (e) {
      console.error('Error during create wallet to trading account transaction', e)
    }
  }
}

export const fetchTransactionReasonStatusAction = (
  walletsApiClient: WalletsApiClient,
  transactionTypeId?: number
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getTransactionReasonsStatus(transactionTypeId)
      dispatch(transactionSlice.actions.setTransactionStatusReasonAction(response))
    } catch (e) {
      console.error('Error during get transaction status reasons.', e)
    }
  }
}

export const fetchTransactionTypeAction = (
  walletsApiClient: WalletsApiClient,
  query?: PageQuery
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getTransactionTypes(query)
      dispatch(transactionSlice.actions.setTransactionTypeAction(response))
    } catch (e) {
      console.error('Error during get transaction types', e)
    }
  }
}

export const fetchBonusTransactionTypeAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getBonusTransactionTypes()
      dispatch(transactionSlice.actions.setTransactionBonusTypeAction(response.items))
    } catch (e) {
      console.error('Error during get bonus types', e)
    }
  }
}

export const fetchBonusTransactionStatusesAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getBonusTransactionStatuses()
      dispatch(transactionSlice.actions.setTransactionBonusStatusesAction(response))
    } catch (e) {
      console.error('Error during get bonus types', e)
    }
  }
}

export const fetchPaymentProviderAction = (paymentApiClient: PaymentApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await paymentApiClient.getPaymentProviders()
      const providerType: PaymentMethodDto[] = response
      dispatch(transactionSlice.actions.setPaymentProviderAction(providerType))
    } catch (e) {
      console.error('Error during get payment providers.', e)
    }
  }
}

export const updateTransactionStatusAction = (
  walletsApiClient: WalletsApiClient,
  status: { name: string; id: number },
  data: UpdateTransactionStatus,
  setFieldValue: (field: string, value: { name: string; id: number }) => void,
  setToast?: (toast: Toast) => void
) => {
  return async (): Promise<void> => {
    try {
      await walletsApiClient.updateTransactionStatus(status.id, data)
      if (setToast) {
        setToast({ type: 'success', title: 'Transaction status updated.' })
      }
      setFieldValue('state', status)
    } catch (e) {
      console.error('Error during update transaction status.', e)
    }
  }
}

export const fetchTransactionStatusAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getTransactionStatus()
      dispatch(transactionSlice.actions.setTransactionStatusAction(response))
    } catch (e) {
      console.error('Error during create wallet to trading account transaction', e)
    }
  }
}

export const fetchDirectionType = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getDirectionTypes()
      dispatch(transactionSlice.actions.setTransactionDirectionTypeAction(response))
    } catch (e) {
      console.error('Error during get transaction direction types', e)
    }
  }
}
